const setModal = () => {
  const open = document.querySelectorAll('[data-modal-open]');
  open.forEach(item => {
    if (document.getElementById(item.dataset.modalOpen)) {
      const target = document.getElementById(item.dataset.modalOpen);
      item.addEventListener('click', (event) => {
        event.preventDefault();
        target.open();
      })
    } else {
      console.warn('No target.')
    }
  })
  const close = document.querySelectorAll('[data-modal-close]');
  close.forEach(item => {
    if (document.getElementById(item.dataset.modalOpen)) {
      const target = document.getElementById(item.dataset.modalOpen);
      item.addEventListener('click', (event) => {
        event.preventDefault();
        target.close();
      })
    } else {
      console.warn('No target.')
    }
  })
}
setModal();

class ohrModal extends HTMLElement {
  constructor() {
    super();
    this.backdrop = null;
    this.querySelectorAll('.modal-close').forEach(item => {
      item.addEventListener('click', this.close.bind(this));
    })
    if (this.dataset.forceOpen && this.dataset.forceOpen.toLowerCase() === 'true') {
      this.open();
    }
  }
  toggleBackdrop (show = true) {
    if (!this.backdrop) {
      const backdrop = document.createElement('div');
      backdrop.className = 'toast-backdrop';
      this.appendChild(backdrop);
      this.backdrop = backdrop;
      backdrop.addEventListener('click', this.close.bind(this));
    } else {
      this.removeChild(this.backdrop);
      this.backdrop = null;
    }

  }
  open() {
    this.toggleBackdrop()
    this.classList.remove('hidden');
  }
  close() {
    this.toggleBackdrop()
    this.classList.add('hidden');
  }

}
customElements.define("ohr-modal", ohrModal);


class MainTab extends HTMLElement {
  constructor() {
    super();
    this.tabButton = this.querySelectorAll('.tab-item a');
    this.tabBody = this.querySelectorAll('.tab-body');
    this.init();
  }
  init() {
    this.tabButton.forEach(item => {
      item.addEventListener('click', this.setTab.bind(this));
    });
    this.tabBody.forEach((item, index) => {
      item.classList.toggle('hidden', index !== 0);
    })
  }
  setTab(event) {
    event.preventDefault();
    const index = parseInt(event.currentTarget.dataset.index);
    console.log(index)
    this.tabButton.forEach((item, idx) => {
      item.classList.toggle('active', idx === index);
    })
    this.tabBody.forEach((item, idx) => {
      item.classList.toggle('hidden', idx !== index);
    });
    const changeEvent = new CustomEvent('tab:changed', { detail: { tabIndex: index } });
    this.dispatchEvent(changeEvent);
  }
}
customElements.define('main-tab', MainTab);


document.addEventListener("DOMContentLoaded", () => {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const bundles = {};

      cart.items.forEach(item => {
        const bundleId = item.properties?._bundle_id;
        if (!bundleId) return;

        if (!bundles[bundleId]) {
          bundles[bundleId] = {
            master: null,
            items: []
          };
        }

        bundles[bundleId].items.push(item);
        if (item.properties.__bundle === 'true') {
          bundles[bundleId].master = item;
        }
      });

      const updates = {};

      Object.entries(bundles).forEach(([bundleId, data]) => {
        if (!data.master) {
          // No master item — remove all items from this bundle
          data.items.forEach(item => {
            updates[item.key] = 0;
          });
        }
      });

      if (Object.keys(updates).length > 0) {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        }).then(() => {
          if (typeof refreshCartDrawer === 'function') {
            refreshCartDrawer();
          } else {
            location.reload();
          }
        });
      }
    })
    .catch(err => console.error("Error validating bundles in cart:", err));
});


// swiper 초기화

function safeInitSwiper(getEl, initCallback, retry = 0) {
  const el = typeof getEl === "function" ? getEl() : getEl;
  if (!el) return;

  // 스와이퍼가 보이는 상태일 때만 초기화
  if (el.offsetWidth > 0 && el.offsetHeight > 0) {
    initCallback(el);
    return;
  }

  // 최대 20번까지 체크 (약 400ms)
  if (retry < 20) {
    requestAnimationFrame(() => safeInitSwiper(getEl, initCallback, retry + 1));
  }
}





// ohr-section-columns
class OhoraColumns extends HTMLElement {
  constructor() {
    super();
    this._initialized = false;
  }

  initSwiper() {
    if (this._initialized) return;

    const sectionId = this.dataset.sectionId;
    const swiperEl = this.querySelector(`.swiper-${sectionId}`);
    if (!swiperEl) return;

    const doInit = () => {
      if (swiperEl.offsetWidth === 0) {
        requestAnimationFrame(doInit);
        return;
      }

      this._initialized = true;

      new Swiper(swiperEl, {
        pagination: {
          el: swiperEl.querySelector('.ohora-columns-pagination'),
          clickable: true
        },
        navigation: {
          nextEl: swiperEl.querySelector('.ohora-column-next-btn'),
          prevEl: swiperEl.querySelector('.ohora-column-prev-btn'),
        },
        breakpoints: {
          0: {
            slidesPerView: 1.1,
            spaceBetween: 22
          },
          768: {
            slidesPerView: 2.1,
            spaceBetween: 22
          },
          1024: {
            slidesPerView: 2.8,
            spaceBetween: 35
          }
        }
      });
    };

    requestAnimationFrame(doInit);
  }

  connectedCallback() {
    this.initSwiper();
  }
}

if (!customElements.get('ohora-columns')) {
  customElements.define('ohora-columns', OhoraColumns);
}

document.addEventListener('shopify:section:load', (event) => {
  const el = event.target;
  el.querySelectorAll('ohora-columns').forEach(component => {
    component.initSwiper();
  });
});



// ohora-image-with-text.liquid
class IWTDuo extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    safeInitSwiper(
      () => this.querySelector('.iwt-left-swiper'),
      () => this.initSwipers()
    );
  }

  initSwipers() {
    const leftEl = this.querySelector('.iwt-left-swiper');
    const rightEl = this.querySelector('.iwt-right-swiper');
    if (!leftEl || !rightEl) return;

    const isMobile = window.innerWidth <= 768;

    /* LEFT : IMAGE */
    const leftSwiper = new Swiper(leftEl, {
      loop: false,
      speed: 600,
      pagination: {
        el: this.querySelector('.iwt-pagination-left'),
        clickable: true
      }
    });

    /* RIGHT : TEXT */
    const rightSwiper = new Swiper(rightEl, {
      loop: false,
      speed: 500,
      autoHeight: true,

      // ⭐ PC / Mobile 분기
      direction: 'horizontal',
      effect: isMobile ? 'slide' : 'fade',
      fadeEffect: isMobile ? undefined : { crossFade: true },

      pagination: {
        el: this.querySelector('.iwt-pagination-bottom'),
        clickable: true
      }
    });

    /* SYNC */
    leftSwiper.controller.control = rightSwiper;
    rightSwiper.controller.control = leftSwiper;
  }
}

customElements.define("iwt-duo", IWTDuo);




// ohora-video.liquid
if (!customElements.get('ohr-simple-video')) {
  class OhoraSimpleVideo extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this._scrollHandler = null;
      this._raf = null;
      this._latestY = 0;
    }

    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;

      this.initVideoControls();
      this.initAutoplayState();
      this.initScrollShrink(); // ✅ 개선된 shrink
    }

    /* ----------------------------------------
       0) Scroll Shrink (PC + Mobile / rAF)
       ---------------------------------------- */
    initScrollShrink() {
      const wrap = this.querySelector(".simplevideo-wrapper");
      if (!wrap) return;

      const update = () => {
        this._raf = null;

        const isMobile = window.innerWidth <= 768;

        const vh = window.innerHeight;
        const rect = wrap.getBoundingClientRect();
        const centerY = rect.top + rect.height / 2;

        const trigger = isMobile ? vh * 0.6 : vh * 0.55;
        const range   = isMobile ? vh * 0.45 : vh * 0.35;

        let p = (trigger - centerY) / range;
        p = Math.max(0, Math.min(1, p));

        const scaleMin  = isMobile ? 0.93 : 0.94;
        const radiusMax = 15;

        const scale  = 1 - (1 - scaleMin) * p;
        const radius = radiusMax * p;

        wrap.style.transform = `scale(${scale})`;
        wrap.style.clipPath  = `inset(0% round ${radius}px)`;
      };

      const onScroll = () => {
        if (this._raf) return;
        this._raf = requestAnimationFrame(update);
      };

      this._scrollHandler = onScroll;

      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll);

      update(); // 초기 적용
    }

    disconnectedCallback() {
      if (this._scrollHandler) {
        window.removeEventListener("scroll", this._scrollHandler);
        window.removeEventListener("resize", this._scrollHandler);
      }
      if (this._raf) cancelAnimationFrame(this._raf);
    }

    /* ----------------------------------------
       Autoplay Icon Sync (기존 유지)
       ---------------------------------------- */
    initAutoplayState() {
      const wrappers = this.querySelectorAll(".simplevideo-wrapper");

      wrappers.forEach((wrap) => {
        const video = this.getVisibleVideoFrom(wrap);
        if (!video) return;

        const btn = wrap.querySelector(".simplevideo-play-btn");
        if (!btn) return;

        const playIcon = btn.querySelector(".play-icon");
        const pauseIcon = btn.querySelector(".pause-icon");

        video.addEventListener("canplay", () => {
          setTimeout(() => {
            if (!video.paused) {
              playIcon.style.display = "none";
              pauseIcon.style.display = "block";
            }
          }, 50);
        });

        video.addEventListener("play", () => {
          playIcon.style.display = "none";
          pauseIcon.style.display = "block";
        });

        video.addEventListener("pause", () => {
          playIcon.style.display = "block";
          pauseIcon.style.display = "none";
        });
      });
    }

    getVisibleVideoFrom(wrap) {
      const videos = [...wrap.querySelectorAll("video")];
      if (!videos.length) return null;
      const visible = videos.find(v => v.offsetParent !== null);
      return visible || videos[0];
    }

    /* ----------------------------------------
       Video Controls (기존 유지)
       ---------------------------------------- */
    initVideoControls() {
      const wrappers = this.querySelectorAll(".simplevideo-wrapper");

      wrappers.forEach((wrap) => {
        const btn = wrap.querySelector(".simplevideo-play-btn");
        if (!btn) return;

        const playIcon = btn.querySelector(".play-icon");
        const pauseIcon = btn.querySelector(".pause-icon");

        const toggleVideo = () => {
          const video = this.getVisibleVideoFrom(wrap);
          if (!video) return;

          if (video.paused) {
            video.play();
            playIcon.style.display = "none";
            pauseIcon.style.display = "block";
          } else {
            video.pause();
            playIcon.style.display = "block";
            pauseIcon.style.display = "none";
          }
        };

        btn.addEventListener("click", (e) => {
          e.stopPropagation();
          toggleVideo();
        });

        wrap.addEventListener("click", (e) => {
          if (e.target.closest(".simplevideo-play-btn")) return;
          toggleVideo();
        });
      });
    }
  }

  customElements.define("ohr-simple-video", OhoraSimpleVideo);
}



//ohora-feature-slides
class OhoraFeatureSplit extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.textEl = this.querySelector('.feature-text-swiper');
    this.imageEl = this.querySelector('.feature-image-swiper');
    this.countCurrent = this.querySelector('.count-current');

    if (!this.textEl || !this.imageEl) return;

    this.initSwipers();
  }

  initSwipers() {
    /* =========================
       TEXT SWIPER (fade-up only)
    ========================= */
    this.textSwiper = new Swiper(this.textEl, {
      slidesPerView: 1,
      speed: 600,
      allowTouchMove: true,

      // ⭐ 핵심: 좌우 이동 제거
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },

      pagination: {
        el: this.querySelector('.feature-text-pagination'),
        clickable: true
      },

      on: {
        init: sw => this.updateActive(sw.activeIndex),
        slideChange: sw => this.updateActive(sw.activeIndex)
      }
    });

    /* =========================
       IMAGE SWIPER
    ========================= */
    this.imageSwiper = new Swiper(this.imageEl, {
      slidesPerView: 1,
      speed: 600,
      allowTouchMove: true,

      pagination: {
        el: this.querySelector('.feature-image-pagination'),
        clickable: true
      }
    });

    /* =========================
       SYNC BOTH
    ========================= */
    this.textSwiper.controller.control = this.imageSwiper;
    this.imageSwiper.controller.control = this.textSwiper;
  }

  /* =========================
     Fade-up active control
  ========================= */
  updateActive(index) {
    const slides = this.querySelectorAll('.feature-slide');

    slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === index);
    });

    if (this.countCurrent) {
      this.countCurrent.textContent = index + 1;
    }
  }
}

customElements.define('ohora-feature-split', OhoraFeatureSplit);




// tab-image-switcher.liquid
class TabImageSwitcher extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const dataEl = this.querySelector(".tis-data");
    if (!dataEl) return;

    this.images = JSON.parse(dataEl.textContent).images;

    this.pcImg = this.querySelector(".pc-img");
    this.mobileImg = this.querySelector(".mobile-img");
    this.tabs = this.querySelectorAll(".tis-tab");

    this.activeColor = this.dataset.activeColor;

    this.initEvents();
    this.applyInitialActiveStyle();
  }

  initEvents() {
    this.tabs.forEach((tab, index) => {
      tab.addEventListener("click", () => this.updateImage(index));
    });
  }

  applyInitialActiveStyle() {
    this.tabs.forEach(tab => {
      if (tab.classList.contains("is-active")) {
        tab.style.backgroundColor = this.activeColor;
      }
    });
  }

  updateImage(index) {
    const item = this.images[index];

    if (this.pcImg) this.pcImg.src = item.pc;
    if (this.mobileImg) this.mobileImg.src = item.mobile;

    this.tabs.forEach(tab => {
      tab.classList.remove("is-active");
      tab.style.backgroundColor = "#c8c8c8";
    });

    this.tabs[index].classList.add("is-active");
    this.tabs[index].style.backgroundColor = this.activeColor;
  }
}

customElements.define("tab-image-switcher", TabImageSwitcher);





// swatch-button-products.liquid
class SwatchButtonProducts extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    this.slides = [...this.querySelectorAll(".sbp-slide")];
    this.swatches = [...this.querySelectorAll(".sbp-swatch-btn")];
    this.swiperContainer = this.querySelector(".sbp-swiper");

    this.initSwiper();
    this.bindSwatches();
    this.activateIndex(0);
  }

  /* ===========================
     Swiper 초기화 (PC/Mobile 전환 자동)
  =========================== */
  initSwiper() {
    this.swiper = new Swiper(this.swiperContainer, {
      slidesPerView: 1.6,
      spaceBetween: 12,
      allowTouchMove: true,

      breakpoints: {
        769: {
          slidesPerView: 4,
          spaceBetween: 32,
          allowTouchMove: true,
        }
      },

      on: {
        // Use the swiper arg: these can fire during init, before this.swiper is assigned
        slideChange: (swiper) => this.handleSlideChange(swiper),
        // Last snap (maxTranslate) keeps the same activeIndex, so slideChange won't fire there
        snapIndexChange: (swiper) => this.handleSlideChange(swiper),
      }

    });
  }

  /* ===========================
     공통 index 활성화
  =========================== */
  activateIndex(index) {
    this.slides.forEach((s) => s.classList.remove("is-active"));
    this.swatches.forEach((s) => s.classList.remove("is-active"));

    this.slides[index]?.classList.add("is-active");
    this.swatches[index]?.classList.add("is-active");
  }

  /* ===========================
     PC/Mobile 스와치 이벤트
  =========================== */
  bindSwatches() {
    this.swatches.forEach((btn) => {
      const index = Number(btn.dataset.index);

      // PC: hover
      btn.addEventListener("mouseenter", () => {
        if (window.innerWidth >= 769) {
          this.swiper.slideTo(index);
          this.activateIndex(index);
        }
      });

      // Mobile: click
      btn.addEventListener("click", () => {
        if (window.innerWidth < 769) {
          this.swiper.slideTo(index);
          this.activateIndex(index);
        }
      });
    });
  }

  /* ===========================
     Swiper 변경될 때 스와치 sync
  =========================== */
  handleSlideChange(swiper = this.swiper) {
    if (window.innerWidth >= 769) return; // PC 제외
    if (!swiper) return;

    // At the end the last slide can't reach the left edge, so activate it explicitly
    if (swiper.isEnd) {
      this.activateIndex(this.slides.length - 1);
      return;
    }

    const translate = swiper.translate * -1;
    let bestIndex = 0;
    let minDistance = Infinity;

    this.slides.forEach((slide, idx) => {
      const dist = Math.abs(slide.offsetLeft - translate);
      if (dist < minDistance) {
        minDistance = dist;
        bestIndex = idx;
      }
    });

    this.activateIndex(bestIndex);
  }
  
}

customElements.define("swatch-button-products", SwatchButtonProducts);





// ohora-formula
class SyrupFormula extends HTMLElement {
  constructor() {
    super();
    this.handleSwatchClick = this.handleSwatchClick.bind(this);
  }

  connectedCallback() {
    this.mainImageEl = this.querySelector('[data-role="main-image"]');
    this.swatchEls = Array.from(this.querySelectorAll('[data-role="syrup-swatch"]'));

    if (!this.mainImageEl || !this.swatchEls.length) return;

    // 중첩 블록 구조(ohora-formula3)에서는 group 블록 자신 안에서 읽는 block.id와
    // 섹션의 section.blocks에서 바깥에서 읽는 block.id가 서로 다른 값으로 나오는
    // Shopify 자체 동작 때문에, Liquid가 심어둔 data-group-uid/data-group-content가
    // 서로 안 맞을 수 있다. 그래서 그 값은 무시하고, 연결 시점에 DOM 순서로 직접
    // 그룹 ↔ Add to Cart 폼을 다시 짝지어 덮어쓴다.
    const groupEls = Array.from(this.querySelectorAll('[data-role="formula-group"]'));
    if (groupEls.length) {
      const headerForms = Array.from(this.querySelectorAll('.formula-header-btns [data-atc-form]'));
      const mobileForms = Array.from(this.querySelectorAll('.formula-mobile-btns [data-atc-form]'));

      groupEls.forEach((groupEl, i) => {
        const uid = 'formula-group-idx-' + i;
        groupEl.dataset.groupUid = uid;
        if (headerForms[i]) headerForms[i].dataset.groupContent = uid;
        if (mobileForms[i]) mobileForms[i].dataset.groupContent = uid;
      });
    }

    // 이벤트 등록
    this.swatchEls.forEach((btn) => {
      btn.addEventListener('click', this.handleSwatchClick);
    });

    // 기본 그룹은 water → water 첫 스와치 선택
    const defaultGroup = this.dataset.defaultGroup || 'water';

    const groupSwatches = this.swatchEls.filter(
      (btn) => btn.dataset.group === defaultGroup
    );

    const initialSwatch = groupSwatches[0] || this.swatchEls[0];

    // 첫 번째 스와치를 자동 적용
    this.setActiveSwatch(initialSwatch);
  }

  disconnectedCallback() {
    this.swatchEls.forEach((btn) => {
      btn.removeEventListener('click', this.handleSwatchClick);
    });
  }

  handleSwatchClick(event) {
    const btn = event.currentTarget;
    this.setActiveSwatch(btn);
  }

  setActiveSwatch(btn) {
    if (!btn) return;

    // 스와치 active 표시
    this.swatchEls.forEach((el) => {
      el.classList.toggle('is-active', el === btn);
    });

    // 메인 이미지 변경
    const imgSrc = btn.dataset.mainImage;
    const imgAlt = btn.dataset.mainAlt || '';

    if (imgSrc) {
      this.mainImageEl.src = imgSrc;
    }
    this.mainImageEl.alt = imgAlt;

    // 메인 이미지 NEW 배지 동기화 (선택된 스와치에 NEW가 있을 때만 노출)
    const mainImageBadge = this.querySelector('[data-role="main-image-badge"]');
    if (mainImageBadge) {
      mainImageBadge.hidden = btn.dataset.newBadge !== 'true';
    }

    const variantId = btn.dataset.variantId || '';
    const label = btn.dataset.label || '';

    // 중첩 블록 구조(ohora-formula3: group 블록 안에 swatch 블록)인지 확인 —
    // 이 경우 그룹 식별은 select 값 매칭이 아니라 실제 부모 DOM으로 판단한다.
    const groupEl = btn.closest('[data-role="formula-group"]');

    let group;
    if (groupEl) {
      group = groupEl.dataset.groupUid;

      // 이 그룹 안의 active-label만 갱신 (다른 그룹 라벨은 비움 — 기존 동작과 동일)
      this.querySelectorAll('.formula-swatch-active-label').forEach((el) => { el.textContent = ''; });
      const labelEl = groupEl.querySelector('.formula-swatch-active-label');
      if (labelEl) labelEl.textContent = label;

      // group_1..7 같은 고정 값이 아니라 임의의 block.id라서 CSS로 미리 나열할 수 없음 → JS로 직접 노출 전환
      this.querySelectorAll('[data-atc-form]').forEach((form) => {
        form.hidden = form.dataset.groupContent !== group;
      });
    } else {
      // 기존 평면 구조(ohora-formula2: swatch가 select 값으로 그룹을 표시) — 그대로 유지
      group = btn.dataset.group;
      this.dataset.activeGroup = group;
    }

    // 해당 그룹의 Add to Cart 폼(데스크탑/모바일)에 선택된 스와치의 상품/텍스트 반영
    this.querySelectorAll('[data-atc-form][data-group-content="' + group + '"]').forEach((form) => {
      const idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.value = variantId;

      const baseText = form.dataset.baseText || '';
      const btnText = form.querySelector('.btn-text');
      if (btnText) btnText.textContent = label ? (baseText + ' ' + label) : baseText;

      const submitBtn = form.querySelector('[data-add-to-cart]');
      if (submitBtn) submitBtn.disabled = !variantId;
    });
  }
}

if (!customElements.get('syrup-formula')) {
  customElements.define('syrup-formula', SyrupFormula);
}



//ohora-text-switcher.liquid
class FtsSwitcher extends HTMLElement {
  connectedCallback() {
    this.textItems = [...this.querySelectorAll('.fts-text-item')];
    this.bullets = [...this.querySelectorAll('.fts-bullet')];

    /* IMAGE SWIPER (DESKTOP) */
    this.imageSwiper = new Swiper(
      this.querySelector('.fts-image-swiper'),
      {
        slidesPerView: 1,
        speed: 700,
        pagination: {
          el: this.querySelector('.fts-image-pagination'),
          clickable: true
        },
        on: {
          slideChange: (sw) => {
            this.activate(sw.activeIndex);
          }
        }
      }
    );

    /* BULLET HOVER */
    this.bullets.forEach(btn => {
      btn.addEventListener('mouseenter', () => {
        const i = Number(btn.dataset.index);
        this.imageSwiper.slideTo(i);
        this.activate(i);
      });
    });

    /* MOBILE */
    new Swiper(this.querySelector('.fts-mobile-swiper'), {
      slidesPerView: 1,
      speed: 600,
      pagination: {
        el: this.querySelector('.fts-mobile .swiper-pagination'),
        clickable: true
      }
    });
  }

  activate(index) {
    this.textItems.forEach((el, i) =>
      el.classList.toggle('is-active', i === index)
    );
    this.bullets.forEach((el, i) =>
      el.classList.toggle('is-active', i === index)
    );
  }
}

customElements.define('fts-switcher', FtsSwitcher);





// ohora-image-with-product.liquid
class OhoraDuoSlider extends HTMLElement {
  connectedCallback() {
    setTimeout(() => this.init(), 80);
  }

  init() {
    const id = this.dataset.sectionId;

    const leftEl = document.querySelector(`.duo-left-swiper-${id}`);
    const rightEl = document.querySelector(`.duo-right-swiper-${id}`);
    if (!leftEl || !rightEl) return;

    const leftSwiper = new Swiper(`.duo-left-swiper-${id}`, {
      loop: false,
      pagination: {
        el: `.duo-left-pagination-${id}`,
        clickable: true
      }
    });

    const rightSwiper = new Swiper(`.duo-right-swiper-${id}`, {
      loop: false,
      navigation: {
        nextEl: `.next-${id}`,
        prevEl: `.prev-${id}`
      },
      pagination: {
        el: `.duo-right-pagination-mobile-${id}`,
        clickable: true
      }
    });

    leftSwiper.controller.control = rightSwiper;
    rightSwiper.controller.control = leftSwiper;
  }
}

customElements.define("ohora-duo-slider", OhoraDuoSlider);







// ohr-section-how-to.liquid
// ohr-section-how-to.liquid
(function () {
  if (window.OhoraHowToUse) return;

  class OhoraHowToUse {
    constructor(sectionEl) {
      this.section = sectionEl;
      this.id = sectionEl.dataset.howtoSection;

      this._scrollHandler = null;

      this.initTabs();
      this.initVideoControls();
      this.initStepsSwiper();
      this.initScrollShrink(); // ⭐ mobile 포함 scroll shrink
    }

    /* ----------------------------------------
       1) Tabs
       ---------------------------------------- */
    initTabs() {
      const tabs = this.section.querySelectorAll(".howto-tab");
      const blocks = this.section.querySelectorAll(".howto-content-block");
      const slider = this.section.querySelector(".pill-slider");

      const count = tabs.length;
      const segment = 100 / count;

      if (slider) {
        slider.style.width = segment + "%";
      }

      tabs.forEach((tab, index) => {
        tab.addEventListener("click", () => {
          tabs.forEach(t => t.classList.remove("active"));
          tab.classList.add("active");

          const target = tab.dataset.tab;
          blocks.forEach(block =>
            block.classList.toggle("active", block.dataset.content === target)
          );

          if (slider) {
            slider.style.left = index * segment + "%";
          }

          this.resetAllVideos();
          this.updateScrollShrinkTargets(); // 탭 변경 시 shrink 타겟 갱신
        });
      });
    }

    /* ----------------------------------------
       2) Video Controls
       ---------------------------------------- */
    initVideoControls() {
      const wraps = this.section.querySelectorAll(".howto-video-grandparent");

      wraps.forEach(wrap => {
        const btn = wrap.querySelector(".howto-video-toggle");
        if (!btn) return;

        const playIcon = btn.querySelector(".icon-play");
        const pauseIcon = btn.querySelector(".icon-pause");

        const getVideo = () => {
          const list = [...wrap.querySelectorAll("video")];
          return list.find(v => v.offsetParent !== null) || list[0];
        };

        const setIcons = playing => {
          playIcon.style.display = playing ? "none" : "block";
          pauseIcon.style.display = playing ? "block" : "none";
        };

        const toggle = () => {
          const video = getVideo();
          if (!video) return;

          if (video.paused) {
            video.play();
            setIcons(true);
          } else {
            video.pause();
            setIcons(false);
          }
        };

        btn.addEventListener("click", e => {
          e.stopPropagation();
          toggle();
        });

        wrap.addEventListener("click", e => {
          if (e.target.closest(".howto-video-toggle")) return;
          toggle();
        });
      });
    }

    resetAllVideos() {
      this.section.querySelectorAll("video").forEach(v => {
        v.pause();
        v.currentTime = 0;
      });

      this.section.querySelectorAll(".icon-play").forEach(el => (el.style.display = "block"));
      this.section.querySelectorAll(".icon-pause").forEach(el => (el.style.display = "none"));
    }

    /* ----------------------------------------
       3) Steps swiper (⭐ 최소 10% 적용)
       ---------------------------------------- */
    initStepsSwiper() {
      if (typeof Swiper === "undefined") return;

      const swipers = this.section.querySelectorAll(".howto-steps-swiper");

      swipers.forEach(swEl => {
        const wrap = swEl.closest(".howto-steps-wrapper");
        const fill = wrap?.querySelector(".howto-steps-progress-fill");

        const swiper = new Swiper(swEl, {
          slidesPerView: 4,
          spaceBetween: 20,
          watchSlidesProgress: true,
          breakpoints: {
            0: { slidesPerView: 2.3, spaceBetween: 14 },
            768: { slidesPerView: 4, spaceBetween: 20 }
          },
          on: {
            progress(sw, p) {
              if (fill) {
                const pct = Math.max(0, Math.min(1, p));
                const barWidth = Math.max(10, pct * 100);
                fill.style.width = barWidth + "%";
              }
            },
            init(sw) {
              const p = sw.progress;
              if (fill) {
                const pct = Math.max(0, Math.min(1, p));
                const barWidth = Math.max(10, pct * 100);
                fill.style.width = barWidth + "%";
              }
            }
          }
        });

        swiper.emit("init");
      });
    }

    /* ----------------------------------------
       4) Scroll Shrink (PC + Mobile)
       ---------------------------------------- */
    updateScrollShrinkTargets() {
      this.fullBleed = this.section.querySelector(
        ".howto-content-block.active .howto-video-fullbleed"
      );
      this.grand = this.section.querySelector(
        ".howto-content-block.active .howto-video-grandparent"
      );
    }

    initScrollShrink() {
      this.updateScrollShrinkTargets();

      const onScroll = () => {
        if (!this.fullBleed || !this.grand) return;

        const isMobile = window.innerWidth <= 768;

        const vh = window.innerHeight;
        const rect = this.fullBleed.getBoundingClientRect();
        const centerY = rect.top + rect.height / 2;

        // 🔹 PC / Mobile 파라미터 분기
        const trigger = isMobile ? vh * 0.6 : vh * 0.5;
        const range   = isMobile ? vh * 0.35 : vh * 0.25;

        let p = (trigger - centerY) / range;
        p = Math.max(0, Math.min(1, p));

        const scaleMin  = isMobile ? 0.96 : 0.94;
        const radiusMax = isMobile ? 14  : 20;

        const scale  = 1 - (1 - scaleMin) * p;
        const radius = radiusMax * p;

        this.grand.style.transform = `scale(${scale})`;
        this.grand.style.clipPath  = `inset(0% round ${radius}px)`;
      };

      this._scrollHandler = onScroll;
      window.addEventListener("scroll", onScroll, { passive: true });
      window.addEventListener("resize", onScroll);

      onScroll();
    }

    destroy() {
      if (this._scrollHandler) {
        window.removeEventListener("scroll", this._scrollHandler);
        window.removeEventListener("resize", this._scrollHandler);
      }
      this.resetAllVideos();
    }
  }

  const INST = {};

  function init(root) {
    const sections = (root || document).querySelectorAll("section[data-howto-section]");
    sections.forEach(sec => {
      const id = sec.dataset.howtoSection;
      if (!INST[id]) INST[id] = new OhoraHowToUse(sec);
    });
  }

  document.addEventListener("DOMContentLoaded", () => init(document));
  document.addEventListener("shopify:section:load", e => init(e.target));
  document.addEventListener("shopify:section:unload", e => {
    const sec = e.target.querySelector("section[data-howto-section]");
    if (!sec) return;

    const id = sec.dataset.howtoSection;
    if (INST[id]) {
      INST[id].destroy();
      delete INST[id];
    }
  });

  window.OhoraHowToUse = OhoraHowToUse;
})();



// ohr-comparison.liquid
class OhoraCompare extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.sectionId = this.dataset.sectionId;

    this.textSwiperEl = this.querySelector(`.compare-text-swiper-${this.sectionId}`);
    this.imageSwiperEl = this.querySelector(`.compare-image-swiper-${this.sectionId}`);

    this.initSwipers();
    this.initEvents();
    this.activateBrand();
  }

  initSwipers() {
    if (this.textSwiperEl.classList.contains('swiper-initialized')) return;

    this.textSwiper = new Swiper(this.textSwiperEl, {
      speed: 500,
      allowTouchMove: false,
    });

    this.imageSwiper = new Swiper(this.imageSwiperEl, {
      speed: 500,
      allowTouchMove: false,
      effect: 'fade',
      fadeEffect: { crossFade: true }
    });

    this.textSwiper.controller.control = this.imageSwiper;
    this.imageSwiper.controller.control = this.textSwiper;
  }

  initEvents() {
    const brand = this.querySelector('.js-brand-title');
    const competitor = this.querySelector('.js-competitor-title');

    brand?.addEventListener('mouseenter', () => this.activateBrand());
    competitor?.addEventListener('mouseenter', () => this.activateCompetitor());
  }

  activateBrand() {
    this.textSwiper?.slideTo(0);
    this.imageSwiper?.slideTo(0);

    this.querySelector('.js-brand-title')?.classList.add('is-active');
    this.querySelector('.js-brand-title')?.classList.remove('is-inactive');

    this.querySelector('.js-competitor-title')?.classList.add('is-inactive');
    this.querySelector('.js-competitor-title')?.classList.remove('is-active');
  }

  activateCompetitor() {
    this.textSwiper?.slideTo(1);
    this.imageSwiper?.slideTo(1);

    this.querySelector('.js-competitor-title')?.classList.add('is-active');
    this.querySelector('.js-competitor-title')?.classList.remove('is-inactive');

    this.querySelector('.js-brand-title')?.classList.add('is-inactive');
    this.querySelector('.js-brand-title')?.classList.remove('is-active');
  }
}

customElements.define("ohora-compare", OhoraCompare);





// product.liquid snippet 내 coupon block
class CouponSwiper extends HTMLElement {
  connectedCallback() {
    safeInitSwiper(
      () => this.querySelector(".coupon-swiper-container"),
      () => this.init()
    );
  }

  init() {
    if (this.initialized) return;
    this.initialized = true;

    const swiperEl = this.querySelector(".coupon-swiper-container");
    if (!swiperEl) return;

    // 이미 Swiper가 붙은 경우 방지
    if (swiperEl.classList.contains("swiper-initialized")) return;

    new Swiper(swiperEl, {
      loop: false,
      pagination: {
        el: this.querySelector(".coupon-swiper-pagination"),
        clickable: true
      },
      slidesPerView: 1,
      spaceBetween: 12,
      breakpoints: {
        768: {
          slidesPerView: 1.3,
          spaceBetween: 20
        }
      }
    });
  }
}

customElements.define("coupon-swiper", CouponSwiper);




//ohora-comparison-ba.liquid
class OhoraBeforeAfter extends HTMLElement {
  constructor() {
    super();
    this._initialized = false;

    this.activeIndex = 0;   // 0 = ohora, 1 = others
    this._dragging = false;
    this._dragByUser = false;
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.initElements();
    this.initSwiper();
    this.initTabs();
    this.initBA();

    // 초기 상태
    this.setBA(50, false);
    this.syncUI(0);
  }

  /* ================= Elements ================= */
  initElements() {
    this.tabs = this.querySelectorAll('[data-target]');
    this.ba = this.querySelector('[data-ba]');
    this.handle = this.ba.querySelector('.handle');
  }

  /* ================= Swiper ================= */
  initSwiper() {
    this.swipers = [];

    this.querySelectorAll('.compare-swiper').forEach(el => {
      const swiper = new Swiper(el, {
        slidesPerView: 1,
        speed: 600,
        allowTouchMove: true
      });

      swiper.on('slideChange', () => {
        // 🔒 사용자 드래그로 상태가 바뀐 경우 BA 위치는 유지
        if (this._dragByUser) {
          this._dragByUser = false;
          this.activeIndex = swiper.activeIndex;
          this.syncUI(this.activeIndex);
          return;
        }

        this.activeIndex = swiper.activeIndex;
        this.syncUI(this.activeIndex);
        this.setBA(this.activeIndex === 0 ? 85 : 15, true);
      });

      this.swipers.push(swiper);
    });
  }

  /* ================= Tabs ================= */
  initTabs() {
    this.tabs.forEach(btn => {
      const idx = Number(btn.dataset.target);

      // PC : hover
      btn.addEventListener('mouseenter', () => {
        if (window.matchMedia('(min-width: 769px)').matches) {
          this.goTo(idx);
        }
      });

      // Mobile : click
      btn.addEventListener('click', () => {
        if (window.matchMedia('(max-width: 768px)').matches) {
          this.goTo(idx);
        }
      });
    });
  }

  goTo(index) {
    if (this.activeIndex === index) return;

    this._dragByUser = false; // ❗ 탭 전환은 항상 스냅 대상
    this.activeIndex = index;

    this.swipers.forEach(swiper => swiper.slideTo(index));
    this.syncUI(index);
    this.setBA(index === 0 ? 85 : 15, true);
  }

  /* ================= Before / After ================= */
  initBA() {
    let lastPercent = 50;

    const move = (clientX) => {
      const rect = this.ba.getBoundingClientRect();
      let percent = ((clientX - rect.left) / rect.width) * 100;
      percent = Math.max(0, Math.min(100, percent));

      lastPercent = percent;
      this.setBA(percent, false);

      const nextIndex = percent < 50 ? 1 : 0;
      if (nextIndex !== this.activeIndex) {
        this.activeIndex = nextIndex;
        this._dragByUser = true; // 🔥 사용자 드래그로 상태 변경
        this.syncUI(nextIndex);
        this.swipers.forEach(swiper => swiper.slideTo(nextIndex));
      }
    };

    const startDrag = () => {
      this._dragging = true;
    };

    const endDrag = () => {
      if (!this._dragging) return;
      this._dragging = false;
      // ❗ 위치 스냅 없음 — 그대로 유지
    };

    this.handle.addEventListener('mousedown', startDrag);
    this.handle.addEventListener('touchstart', startDrag, { passive: true });

    this.ba.addEventListener('mousemove', e => {
      if (!this._dragging) return;
      move(e.clientX);
    });

    this.ba.addEventListener('touchmove', e => {
      if (!this._dragging || !e.touches[0]) return;
      move(e.touches[0].clientX);
    }, { passive: true });

    document.addEventListener('mouseup', endDrag);
    document.addEventListener('touchend', endDrag);
  }

  /* ================= UI ================= */
  syncUI(index) {
    this.tabs.forEach(btn =>
      btn.classList.toggle('is-active', Number(btn.dataset.target) === index)
    );
  }

  /* ================= BA Position ================= */
  setBA(targetPercent, animate = true) {
    const current =
      parseFloat(this.ba.style.getPropertyValue('--pos')) || 50;

    if (!animate) {
      this.ba.style.setProperty('--pos', `${targetPercent}%`);
      return;
    }

    const duration = 350;
    const startTime = performance.now();

    const animateFrame = (now) => {
      const progress = Math.min((now - startTime) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 2);
      const value = current + (targetPercent - current) * eased;

      this.ba.style.setProperty('--pos', `${value}%`);

      if (progress < 1) {
        requestAnimationFrame(animateFrame);
      }
    };

    requestAnimationFrame(animateFrame);
  }
}

customElements.define('ohora-before-after', OhoraBeforeAfter);




// ohora-vertical-slider.liquid
class OhoraVerticalSlider extends HTMLElement {
  constructor() {
    super();
    this._initialized = false;
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.buttons = this.querySelectorAll('.ohora-vertical-slider__btn');
    this.swiperEl = this.querySelector('.ohora-vertical-slider__swiper');

    if (!this.swiperEl || !this.buttons.length) return;

    this.initSwiper();
    this.bindEvents();
  }

  initSwiper() {
    this.isMobile = window.innerWidth < 769;

    this.swiper = new Swiper(this.swiperEl, {
      direction: 'vertical',
      slidesPerView: 1,
      speed: 350,               // 🔥 빠른 반응
      allowTouchMove: false,
      watchSlidesProgress: true
    });

    this.swiper.slideTo(0, 0);
  }

  bindEvents() {
    this.buttons.forEach((btn) => {
      const index = Number(btn.dataset.index);

      if (this.isMobile) {
        // Mobile: click
        btn.addEventListener('click', () => {
          this.activate(index);
        });
      } else {
        // PC: hover
        btn.addEventListener('mouseenter', () => {
          requestAnimationFrame(() => {
            this.activate(index);
          });
        });
      }
    });
  }

  activate(index) {
    this.buttons.forEach(btn =>
      btn.classList.remove('is-active')
    );
    this.buttons[index]?.classList.add('is-active');
    this.swiper.slideTo(index);
  }
}

customElements.define(
  'ohora-vertical-slider',
  OhoraVerticalSlider
);




// ohora-ba-dropdown.liquid
class OhoraBADropdown extends HTMLElement {
  constructor() {
    super();
    this._initialized = false;
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.initAccordion();
    this.initBeforeAfter();
  }

  /* ================= Accordion ================= */
  initAccordion() {
    this.items = this.querySelectorAll('.bad-item');

    this.items.forEach(item => {
      const trigger = item.querySelector('.bad-trigger');
      const content = item.querySelector('.bad-content');

      if (!trigger || !content) return;

      trigger.addEventListener('click', () => {
        this.items.forEach(other => {
          if (other !== item) {
            other.classList.remove('is-active');
            const c = other.querySelector('.bad-content');
            if (c) c.style.maxHeight = null;
          }
        });

        const isOpen = item.classList.contains('is-active');
        item.classList.toggle('is-active', !isOpen);

        if (!isOpen) {
          content.style.maxHeight = content.scrollHeight + 'px';
        } else {
          content.style.maxHeight = null;
        }
      });
    });
  }

  /* ================= Before / After ================= */
  initBeforeAfter() {
    this.ba = this.querySelector('[data-ba]');
    if (!this.ba) return;

    this.handle = this.ba.querySelector('.bad-handle');
    if (!this.handle) return;

    this.dragging = false;

    const move = (clientX) => {
      const rect = this.ba.getBoundingClientRect();
      let pos = ((clientX - rect.left) / rect.width) * 100;
      pos = Math.max(0, Math.min(100, pos));
      this.ba.style.setProperty('--pos', `${pos}%`);
    };

    const startDrag = () => {
      this.dragging = true;
    };

    const endDrag = () => {
      this.dragging = false;
    };

    this.handle.addEventListener('mousedown', startDrag);
    this.handle.addEventListener('touchstart', startDrag, { passive: true });

    this.addEventListener('mousemove', e => {
      if (!this.dragging) return;
      move(e.clientX);
    });

    this.addEventListener('touchmove', e => {
      if (!this.dragging || !e.touches[0]) return;
      move(e.touches[0].clientX);
    }, { passive: true });

    document.addEventListener('mouseup', endDrag);
    document.addEventListener('touchend', endDrag);
  }
}

customElements.define('ohora-ba-dropdown', OhoraBADropdown);



// ohora-ba-background.liquid
if (!customElements.get('ohora-ba-background')) {
  class OhoraBABackground extends HTMLElement {
    constructor() {
      super();
      this._initialized = false;
    }

    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      this.initBeforeAfter();
    }

    initBeforeAfter() {
      this.ba = this.querySelector('[data-ba]');
      if (!this.ba) return;

      this.handle = this.ba.querySelector('.bab-handle');
      if (!this.handle) return;

      this.dragging = false;

      const move = (clientX) => {
        const rect = this.ba.getBoundingClientRect();
        let pos = ((clientX - rect.left) / rect.width) * 100;
        pos = Math.max(0, Math.min(100, pos));
        this.ba.style.setProperty('--pos', `${pos}%`);
      };

      const startDrag = () => { this.dragging = true; };
      const endDrag  = () => { this.dragging = false; };

      this.handle.addEventListener('mousedown', startDrag);
      this.handle.addEventListener('touchstart', startDrag, { passive: true });

      this.addEventListener('mousemove', e => {
        if (!this.dragging) return;
        move(e.clientX);
      });

      this.addEventListener('touchmove', e => {
        if (!this.dragging || !e.touches[0]) return;
        move(e.touches[0].clientX);
      }, { passive: true });

      document.addEventListener('mouseup', endDrag);
      document.addEventListener('touchend', endDrag);
    }
  }

  customElements.define('ohora-ba-background', OhoraBABackground);
}



// ohora-image-dropdown.liquid
class OhoraDropdownSlider extends HTMLElement {
  constructor() {
    super();
    this._initialized = false;
    this.activeItem = null; 
    this.onResize = null;
  }

  connectedCallback() {
    if (this._initialized) return;
    this._initialized = true;

    this.items = this.querySelectorAll('.ds-item');
    this.initSwiper();
    this.initAccordion();

    this.swiper.slideTo(0, 0);

    this.onResize = this.handleResize.bind(this);
    window.addEventListener('resize', this.onResize);
  }

  disconnectedCallback() {
    if (this.onResize) {
      window.removeEventListener('resize', this.onResize);
    }
  }

  initSwiper() {
    this.swiper = new Swiper(this.querySelector('.ds-swiper'), {
      direction: 'vertical',
      slidesPerView: 1,
      speed: 700,
      allowTouchMove: false
    });
  }

  initAccordion() {
    this.items.forEach(item => {
      const trigger = item.querySelector('.ds-trigger');
      if (!trigger) return;

      trigger.addEventListener('click', () => {
        this.toggleItem(item);
      });
    });
  }

  toggleItem(item) {
    const index = Number(item.dataset.index);
    const content = item.querySelector('.ds-content');

    if (this.activeItem === item) {
      item.classList.remove('is-active');
      if (content) content.style.maxHeight = null;

      this.activeItem = null;

      this.swiper.slideTo(0, 700);
      return;
    }

    this.items.forEach(other => {
      if (other !== item) {
        other.classList.remove('is-active');
        const c = other.querySelector('.ds-content');
        if (c) c.style.maxHeight = null;
      }
    });

    item.classList.add('is-active');
    if (content) {
      content.style.maxHeight = content.scrollHeight + 'px';
    }

    this.activeItem = item;

    this.swiper.slideTo(index, 700);
  }

  handleResize() {
    if (!this.activeItem) return;

    const content = this.activeItem.querySelector('.ds-content');
    if (!content) return;

    content.style.maxHeight = content.scrollHeight + 'px';
  }
}

customElements.define('ohora-dropdown-slider', OhoraDropdownSlider);




// ohora-customer-voice.liquid
class OhoraCustomerVoice extends HTMLElement {
  constructor() {
    super();
    this._initialized = false;
  }

  initSwiper() {
    if (this._initialized) return;

    const swiperEl = this.querySelector('.customer-voice-swiper');
    if (!swiperEl) return;

    this._initialized = true;

    new Swiper(swiperEl, {
      pagination: {
        el: this.querySelector('.customer-voice-pagination'),
        clickable: true
      },
      navigation: {
        nextEl: this.querySelector('.customer-voice-next'),
        prevEl: this.querySelector('.customer-voice-prev')
      },
      breakpoints: {
        0: {
          slidesPerView: 1.2,
          spaceBetween: 22
        },
        768: {
          slidesPerView: 2.2,
          spaceBetween: 22
        },
        1024: {
          slidesPerView: 2.8,
          spaceBetween: 35
        }
      }
    });
  }

  connectedCallback() {
    this.initSwiper();
  }
}

if (!customElements.get('ohora-customer-voice')) {
  customElements.define('ohora-customer-voice', OhoraCustomerVoice);
}

document.addEventListener('shopify:section:load', (event) => {
  event.target
    .querySelectorAll('ohora-customer-voice')
    .forEach(el => el.initSwiper());
});


/* ==========================================================================
   Cart drawer — Related products carousel
   --------------------------------------------------------------------------
   Fills [data-cart-related-holder] with the "You may also like" carousel.

   Related recommendations are generated by Shopify on request and are NOT
   stored in a metafield, so they can only be fetched through the Product
   Recommendations API:

     /recommendations/products?section_id=cart-related-products
                              &product_id=<id>&intent=related&limit=<n>

   The API already excludes out of stock products, gift cards, free products
   and products that are already in the cart.

   Base product = the first line item in the cart, which is the most recently
   added one (Shopify prepends new line items).

   `intent=related` is auto-generated by Shopify and legitimately returns nothing
   for some products (no purchase history, imported orders, price 0, gift cards).
   When that happens we walk down the cart — second line item, third, ... — and
   use the first one that does return recommendations.
   ========================================================================== */
class CartRelatedProducts {
  constructor() {
    this.limit = 10;
    // How many cart line items to try before giving up (keeps requests bounded)
    this.maxCandidates = 4;
    this.currentKey = null;
    this.controller = null;
    this.swiper = null;
    this.resizeObserver = null;

    // Fires after theme.js `build()` finishes — i.e. on add, remove and quantity change
    document.addEventListener('theme:cart:added', () => this.refresh());
    // Fires when the drawer markup is cloned out of its <template> for the first time
    document.addEventListener('theme:cart:loaded', () => this.refresh());

    this.refresh();
  }

  get holder() {
    return document.querySelector('[data-cart-related-holder]');
  }

  /**
   * Candidate product ids, in cart order. The first line item is the most
   * recently added one; the rest are fallbacks for when it has no related
   * products of its own.
   */
  getCandidateProductIds() {
    const items = document.querySelectorAll('[data-cart-item][data-product-id]');
    const ids = [];

    items.forEach((item) => {
      const id = item.dataset.productId;
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });

    return ids.slice(0, this.maxCandidates);
  }

  /**
   * Fetch the rendered carousel for one product.
   * Resolves to the [data-cart-related] element, or null when there are no
   * recommendations for that product.
   */
  async fetchRelated(productId, signal) {
    const base = (window.theme && window.theme.routes && window.theme.routes.product_recommendations_url)
      || '/recommendations/products';
    const url = `${base}?section_id=cart-related-products&product_id=${productId}`
      + `&intent=related&limit=${this.limit}`;

    const response = await fetch(url, {signal});

    if (!response.ok) {
      console.warn(`Related products: ${response.status} for product ${productId}`);
      return null;
    }

    const markup = new DOMParser().parseFromString(await response.text(), 'text/html');
    // Section Rendering API wraps the output in #shopify-section-<id>
    const section = markup.querySelector('.shopify-section') || markup.body;

    return section.querySelector('[data-cart-related]');
  }

  async refresh() {
    const holder = this.holder;
    if (!holder) return;

    const ids = this.getCandidateProductIds();

    if (!ids.length) {
      this.clear(holder);
      this.currentKey = null;
      return;
    }

    // Quantity-only changes keep the same line up — skip the requests
    const key = ids.join(',');
    if (key === this.currentKey && holder.innerHTML.trim() !== '') return;

    if (this.controller) this.controller.abort();
    this.controller = new AbortController();
    const signal = this.controller.signal;

    try {
      for (let i = 0; i < ids.length; i++) {
        const content = await this.fetchRelated(ids[i], signal);
        if (!content) continue;

        this.destroySwiper();
        holder.innerHTML = '';
        holder.appendChild(content);
        this.currentKey = key;
        this.initSwiper(holder);
        return;
      }

      // No line item in the cart has related products
      this.clear(holder);
      this.currentKey = key;
    } catch (error) {
      if (error.name !== 'AbortError') console.error(error);
    }
  }

  clear(holder) {
    this.destroySwiper();
    holder.innerHTML = '';
  }

  destroySwiper() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  }

  initSwiper(holder) {
    const slider = holder.querySelector('[data-cart-related-slider]');
    if (!slider || typeof Swiper === 'undefined') return;

    const slideCount = slider.querySelectorAll('.swiper-slide').length;

    this.swiper = new Swiper(slider, {
      slidesPerView: 2.25,
      spaceBetween: 12,
      watchOverflow: true,
      navigation: {
        nextEl: slider.querySelector('[data-cart-related-next]'),
        prevEl: slider.querySelector('[data-cart-related-prev]'),
      },
      breakpoints: {
        480: {slidesPerView: 2.4, spaceBetween: 14},
      },
    });

    if (slideCount > 2) slider.classList.add('is-ready');

    this.syncArrowPosition(slider);
  }

  /**
   * Arrows are centred on the square product image, whose height depends on the
   * slide width. Measure it and expose it as a CSS variable.
   */
  syncArrowPosition(slider) {
    const media = slider.querySelector('.cart-related__media');
    if (!media) return;

    const apply = () => {
      const height = media.getBoundingClientRect().height;
      if (height) slider.style.setProperty('--cart-related-media-h', `${height}px`);
    };

    apply();

    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(apply);
      this.resizeObserver.observe(media);
    }
  }
}

new CartRelatedProducts();

// ohora-tab-collections: one Swiper per tab (same feel as Swatch Button Products),
// lazily initialized when its tab becomes active so hidden tabs never measure 0 width.
class TabCollectionsSwiper extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('.tab'));
    this.swipers = new Map();

    if (!this.tabs.length || typeof Swiper === 'undefined') return;

    this.tabs.forEach((tab) => {
      if (tab.classList.contains('current')) this.initSwiperForTab(tab);
    });

    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const tab = mutation.target;
        if (!tab.classList.contains('current')) return;
        if (this.swipers.has(tab)) {
          this.swipers.get(tab).update();
        } else {
          this.initSwiperForTab(tab);
        }
      });
    });

    this.tabs.forEach((tab) => {
      this.observer.observe(tab, { attributes: true, attributeFilter: ['class'] });
    });
  }

  initSwiperForTab(tab) {
    const swiperEl = tab.querySelector('[data-tab-swiper]');
    if (!swiperEl || this.swipers.has(tab)) return;

    const desktopSlidesPerView = parseFloat(swiperEl.dataset.slidesPerView) || 4;

    const swiper = new Swiper(swiperEl, {
      slidesPerView: 1.6,
      slidesPerGroup: 1,
      spaceBetween: 12,
      allowTouchMove: true,

      breakpoints: {
        769: {
          slidesPerView: desktopSlidesPerView,
          slidesPerGroup: 1,
          spaceBetween: 32,
          allowTouchMove: true,
        }
      },
    });

    this.swipers.set(tab, swiper);
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    this.swipers.forEach((swiper) => swiper.destroy(true, true));
    this.swipers.clear();
  }
}

if (!customElements.get('tab-collections-swiper')) {
  customElements.define('tab-collections-swiper', TabCollectionsSwiper);
}

// 애플 스타일 알약(pill) 탭 네비게이션: 현재 탭(.current) 뒤로 배경 인디케이터가
// 부드럽게 슬라이드되도록 함. 탭 전환 자체(클릭 처리, .current 토글)는
// theme.js의 기존 Tabs 로직이 그대로 담당하고, 여기서는 그 결과(class 변화)만
// 감지해서 인디케이터 위치/너비만 맞춰줍니다.
class TabPillIndicator extends HTMLElement {
  connectedCallback() {
    this.indicator = this.querySelector('.tabs__indicator');
    this.links = Array.from(this.querySelectorAll('.tabs__link'));
    if (!this.indicator || !this.links.length) return;

    this.reposition = this.reposition.bind(this);

    this.observer = new MutationObserver(this.reposition);
    this.links.forEach((link) => {
      this.observer.observe(link, {attributes: true, attributeFilter: ['class']});
    });

    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(this.reposition);
      this.resizeObserver.observe(this);
    }

    requestAnimationFrame(this.reposition);
  }

  reposition() {
    var current = this.links.find(function (link) {
      return link.classList.contains('current');
    });
    if (!current) return;

    this.indicator.style.width = current.offsetWidth + 'px';
    this.indicator.style.transform = 'translateX(' + current.offsetLeft + 'px)';
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this.resizeObserver) this.resizeObserver.disconnect();
  }
}

if (!customElements.get('tab-pill-indicator')) {
  customElements.define('tab-pill-indicator', TabPillIndicator);
}
